// extracted by mini-css-extract-plugin
export default {"wrapper":"BookCatalog_wrapper__kNsiy","error":"BookCatalog_error__LS78L","empty":"BookCatalog_empty__twqsJ"};